export const job_Description_Template = [
  `
    Job Title
[Specify the Job Title]

Job Summary
[Provide a brief overview of the role, including key responsibilities and objectives.]

Key Responsibilities
[Responsibility 1]
[Responsibility 2]
[Responsibility 3]
[Add more as needed]

Required Skills & Qualifications
[Skill 1]
[Skill 2]
[Skill 3]
[Specify relevant experience, education, or certifications]

Preferred Qualifications (Optional)
[Additional skills, certifications, or experience that would be a plus]

Work Environment & Location
[Specify remote/hybrid/onsite and location details]

Compensation & Benefits
[Mention salary range, if applicable]
[Include benefits like health insurance, bonuses, PTO, etc.]

How to Apply
[Provide application instructions, such as submitting a resume, cover letter, or portfolio.]
    `
];
